import ProfileCorps from './ProfileCorps';

export default ProfileCorps;
